var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.to)?_c('router-link',{attrs:{"to":'/'+_vm.$i18n.locale+_vm.to}},[_vm._t("default")],2):_c('div',{staticClass:"cursor-pointer",attrs:{"uk-toggle":'target: '+_vm.target}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }